<template>
    <section
        v-if="pills.length"
        class="pills-list"
    >
        <BasePill
            v-for="pill in pills"
            :key="pill.uri"
            :class="pillsClass"
            :to="`/${pill.uri}`"
            :element="NuxtLink"
        >
            {{ startCase(pill.title) }}
        </BasePill>
    </section>
</template>

<script setup>
const NuxtLink = resolveComponent('NuxtLink');
</script>


<script>
import {startCase} from 'lodash-es';

import BasePill from '~/components/BasePill/BasePill.vue';

export default {
    components: {
        BasePill
    },

    props: {
        pills: {
            type: Array,
            required: false,
            default: () => []
        },
        pillsClass: {
            type: String,
            required: false,
            default: ''
        }
    },

    methods: {
        startCase
    }
};
</script>

<style lang="less" src="./BasePillsList.less" />
